<template>
	<div id="produk">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Pembayaran</li>
      <li class="active">Produk</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Produk</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createProduk()"><span class="fa fa-plus"></span> Tambah Produk</button>
							<button type="button" class="btn btn-success btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								Action <span class="caret"></span>
							</button>
							<ul class="dropdown-menu">
								<li><a @click="updateAllProdukStatus(status.PUBLISH)">Publish All</a></li>
								<li><a @click="updateAllProdukStatus(status.UNPUBLISH)">Unpublish All</a></li>
							</ul>
            </div>
            <h4 class="panel-title">List Produk</h4>
          </div>
          <div class="panel-body">
						<app-datatable 
							:items="produkList" 
							:has-action="true"
							:has-custom-pagination="true"
							:has-custom-search="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
							:headers="headers"
              v-on:selected="selectedRow = $event" 
							v-on:dblClicked="updateProduk()"
							v-on:deleted="deleteProduk($event)"
							v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
						/>
          </div>
        </div>
      </div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import SalesService from '@/services/sales.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'

export default {
	name: 'produk',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			isLoading: false,
			produkList: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Nama', 'Tipe', 'Durasi', 'Tiket', 'Harga', 'Status'],
			headersKey: ['title', 'type', 'value', 'value', 'netPrice', 'status'],
		}
	},
	mounted: function () {
		this.fetchData()
	},
	watch: {
		pagination: function () {
			this.fetchData()
		},
	},
	methods: {
		fetchData: function () {
			var context = this
			var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}

			this.isLoading = true

			SalesService.getProdukList(pagination, search, function (result) {
				context.produkList = []
				context.isLoading = false

				if (result.success) {
					result.data.forEach(function (content) {
						var row = {
							id: content.id,
							data: [
								content.title,
								content.type,
								content.type === 'SUBSCRIPTION' ? content.value + ' bulan' : '-',
								content.type === 'TICKET' ? content.value : '-',
								context.convertToRupiah(content.net_price),
								content.status
							]
						}

						context.pagination.totalPages = content.page
						context.produkList.push(row)
					})
				} else {
					alert('Terjadi kesalahan : ' + result.message)
				}
			})
		},
		createProduk: function () {
			this.$router.push({ path: '/produk/form' })
		},
		updateProduk: function () {
			var produkId = this.selectedRow.id
			this.$router.push({ path: '/produk/form', query: { id: produkId } })
		},
		updateAllProdukStatus: function (status) {
			var context = this
			var confirmed = window.confirm("Apakah anda yakin akan mengupdate semua status produk?")

			if (confirmed) {
				this.isLoading = true
				SalesService.updateAllProdukStatus(status, function (result) {
					context.isLoading = false

					if (result.success) {
						alert('Data Terupdate')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		},
		deleteProduk: function (produk) {
			var context = this
			var produkId = produk.id
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
			if (confirmed) {
				this.isLoading = true
				SalesService.deleteProduk(produkId, function (result) {
					context.isLoading = false

					if (result.success) {
						alert('Data Terhapus')
						context.fetchData()
					} else {
						alert('Terjadi Kesalahan : ' + result.message)
					}
				})
			}
		},
		convertToRupiah: function (value) {
			var rupiah = ''
			var angkarev = value.toString().split('').reverse().join('')
			for (var i = 0; i < angkarev.length; i++) if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.'
			return 'Rp ' + rupiah.split('', rupiah.length - 1).reverse().join('')
		},
	}
}
</script>


// WEBPACK FOOTER //
// Produk.vue?79407cee